<template>
    <div>
      <h1>Project Timeline Visualization</h1>
      <Roadmap 
        :events="timelineData" 
        :width="900" 
        :height="600"
      />
      <button @click="addRandomEvent">{{ $t('add-test-event') }}</button>
    </div>
  </template>
  
  <script>
import Roadmap from '../../components/Roadmap/Roadmap.vue';  

  export default {
    components: {
     Roadmap
    },
    data() {
      return {
        timelineData: [
          {
            id: 1,
            title: 'Start of the year',
            date: '2025-04-04',
            description: 'Initial point'
          },
          {
            id: 2,
            title: 'First milestone',
            date: '2025-06-19',
            description: 'Birthday'
          },
          {
            id: 3,
            title: 'Second milestone',
            date: '2025-09-10',
            description: 'More stuff'
          },
          {
            id: 4,
            title: 'Exam',
            date: '2025-10-15',
            description: 'Study'
          }
        ]
      };
    },
    methods: {
      addRandomEvent() {
        const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        const days = ['01', '15', '20', '28'];
        const year = '2023';
        const randomMonth = months[Math.floor(Math.random() * months.length)];
        const randomDay = days[Math.floor(Math.random() * days.length)];
        
        const newEvent = {
          id: this.timelineData.length + 1,
          title: `Event ${this.timelineData.length + 1}`,
          date: `${year}-${randomMonth}-${randomDay}`,
          description: `Description for event ${this.timelineData.length + 1}`
        };
        
        this.timelineData.push(newEvent);
      }
    }
  };
  </script>